import { Operation } from '../../../__generated__/globalTypes'

import deleteCampaignShareString from '../DeleteCampaignShare.graphql'

export type DeleteCampaignShareData = {
  deleteCampaignShare: {
    deleted: boolean
  }
}

export type DeleteCampaignShareVariables = {
  id: string
}

export type DeleteCampaignShare = Operation<
  DeleteCampaignShareData,
  DeleteCampaignShareVariables
>

export const DeleteCampaignShare = ({
  id,
}: DeleteCampaignShareVariables): DeleteCampaignShare => ({
  query: deleteCampaignShareString,
  variables: {
    id,
  },
})
